import { CaretLeft, CaretRight } from "@phosphor-icons/react";

export const chevronNavButtonClassName =
  "flex size-7 shrink-0 items-center justify-center rounded-lg border border-puntt-neutral-gray-6 bg-base-white text-puntt-neutral-gray-10 transition-colors hover:bg-puntt-neutral-gray-2 disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:bg-base-white";

export function ChevronNavButton({
  direction,
  disabled,
  onClick,
  "aria-label": ariaLabel,
  "data-testid": dataTestId,
}: {
  direction: "left" | "right";
  disabled?: boolean;
  onClick?: () => void;
  "aria-label": string;
  "data-testid"?: string;
}) {
  const Icon = direction === "left" ? CaretLeft : CaretRight;
  return (
    <button
      type="button"
      disabled={disabled}
      onClick={onClick}
      aria-label={ariaLabel}
      data-testid={dataTestId}
      className={chevronNavButtonClassName}
    >
      <Icon size={14} aria-hidden="true" />
    </button>
  );
}
